import { QuizQuestion } from './types';

export const CATEGORIES = [
  { id: 'worldcup', name: '월드컵', icon: '🏆', color: 'bg-gold-500' },
  { id: 'epl', name: 'EPL', icon: '🦁', color: 'bg-purple-600' },
  { id: 'laliga', name: '라리가', icon: '🇪🇸', color: 'bg-yellow-500' },
  { id: 'ucl', name: '챔스', icon: '⭐', color: 'bg-blue-800' },
  { id: 'kleague', name: 'K리그', icon: '🇰🇷', color: 'bg-red-600' }
];

export const STATIC_QUIZZES: Record<string, QuizQuestion[]> = {
  worldcup: [
    {
      id: 'wc-1',
      category: 'worldcup',
      question: '역대 월드컵 최다 우승국은 어디인가요?',
      options: ['독일', '브라질', '이탈리아', '아르헨티나'],
      correctAnswer: 1,
      explanation: '브라질은 총 5회 우승으로 역대 최다 기록을 보유하고 있습니다.'
    },
    {
      id: 'wc-2',
      category: 'worldcup',
      question: '월드컵 단일 대회 최다 득점 기록을 가진 선수는?',
      options: ['펠레', '리오넬 메시', '쥐스트 퐁텐', '미로슬라프 클로제'],
      correctAnswer: 2,
      explanation: '쥐스트 퐁텐(프랑스)은 1958년 스웨덴 월드컵에서 13골을 기록했습니다.'
    }
    // ... 더 많은 문제 추가 가능
  ],
  epl: [
    {
      id: 'epl-1',
      category: 'epl',
      question: '프리미어리그 통산 최다 득점자는?',
      options: ['웨인 루니', '해리 케인', '앨런 시어러', '티에리 앙리'],
      correctAnswer: 2,
      explanation: '앨런 시어러는 260골로 프리미어리그 통산 득점 1위입니다.'
    }
  ],
  ucl: [
    {
      id: 'ucl-1',
      category: 'ucl',
      question: '챔피언스리그 역대 최다 우승 팀은?',
      options: ['AC 밀란', '바이에른 뮌헨', '리버풀', '레알 마드리드'],
      correctAnswer: 3,
      explanation: '레알 마드리드는 통산 15회 우승을 차지했습니다.'
    }
  ]
};
